import { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";

import DstTable from "../../../components/DstTable/DstTable";
import TruncatedText from "../../../components/TruncatedText/TruncatedText";
import { useSession } from "../../../contexts/SessionContext";
import translate from "../../../services/Translate";
import { SessionExercise, SessionExercisesProps } from "./SessionExercises.d";
import { fetchSessionExercises } from "./SessionExercises.function";

const SessionExercises = ({ exerciseIds, sessionId }: SessionExercisesProps) => {
  const { language } = useSession();
  const [exercises, setExercises] = useState<SessionExercise[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSessionExercises(sessionId, setExercises, setLoading, language);
  }, [sessionId, language]);

  if (!exerciseIds.length)
    return <p className="text-muted mb-0">{translate(language, "PAGES.EPHEMERAL_SESSION.NO_EXERCISES")}</p>;

  return (
    <DstTable
      data={exercises}
      loading={loading}
      pagination
      itemsPerPage={20}
      columns={[
        { name: translate(language, "PAGES.EPHEMERAL_SESSION.EXERCISE_ID"), key: "ID" },
        {
          name: translate(language, "PAGES.EPHEMERAL_SESSION.RESUME"),
          key: "resume",
          render: (exercise: SessionExercise) => (
            <TruncatedText text={exercise.resume} lines={4} customClassName="text-break" />
          ),
        },
        {
          name: translate(language, "PAGES.EPHEMERAL_SESSION.ANSWERS"),
          key: "answers",
          render: (exercise: SessionExercise) => (
            <div className="d-flex flex-wrap gap-2">
              {exercise.answers.map((answer, index) => {
                const label = answer.label?.trim() || (index < 26 ? String.fromCharCode(65 + index) : index + 1);
                const text = answer.text.trim();

                return (
                  <Badge key={index} bg={answer.solution ? "success" : "secondary"} className="text-wrap text-start">
                    {text === String(label) || text.startsWith(`${label}.`) ? answer.text : `${label}. ${answer.text}`}
                    {answer.solution && (
                      <span className="ms-1">({translate(language, "PAGES.EPHEMERAL_SESSION.CORRECT_ANSWER")})</span>
                    )}
                  </Badge>
                );
              })}
            </div>
          ),
        },
      ]}
    />
  );
};

export default SessionExercises;
